import React from "react";
import { string, oneOf } from "prop-types";

import { SvgIconHandler } from "../svg-icon-hadler";
import "./icon.m.css";

export const Icon = ({
  name,
  size = "medium",
  color = "primary",
  className = "",
  ...props
}) => {
  const getSizeValue = (size) => {
    switch (size) {
      case "xsmall": return "12";
      case "small": return "16";
      case "medium": return "24";
      case "large": return "32";
      default: return "24";
    }
  };

  const sizeValue = getSizeValue(size);

  return (
    <span
      styleName={`icon ${size} ${color}`}
      className={className}
      {...props}
    >
      <SvgIconHandler
        type={name}
        width={sizeValue}
        height={sizeValue}
        viewBox={`0 0 ${sizeValue} ${sizeValue}`}
      />
    </span>
  );
};

Icon.propTypes = {
  name: string.isRequired,
  size: oneOf(["xsmall","small", "medium", "large"]),
  color: oneOf(["primary", "secondary", "brand", "white"]),
  className: string
};